import { cn } from "@/utils/css";
import { forwardRef } from "react";

export const LoadboardTableCell = forwardRef(({ className, innerClassName = "", children, theme, ...props }, ref) => (
    <td ref={ref} className={cn("align-top text-sm/[22px] text-cm-p-text-primary font-normal p-0 min-h-0", className)} {...props}>
        <div className={cn("h-16 flex items-start px-2 py-2 w-full", innerClassName)}>{children}</div>
    </td>
));
LoadboardTableCell.displayName = "LoadboardTableCell";
